import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    event.preventDefault();
    document.getElementById(href.slice(1))?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full rounded-md border-b-4 border-[#328bc7] bg-brand-ice px-3 py-3 text-center text-sm font-extrabold uppercase leading-tight tracking-wide text-brand-navy shadow-[0_5px_0_0_#328bc7,0_8px_18px_rgba(15,39,74,0.18)] transition duration-200 hover:-translate-y-0.5 hover:bg-[#94d6ff] focus:outline-none focus:ring-4 focus:ring-brand-ice/50 active:translate-y-1 active:border-b-0 sm:text-base ${className}`} data-id="element-33" data-mp="2p09nc672g798">
      {children}
    </a>;
}